exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?minimize!../static/css/main.css"), "");

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21b7a9ee","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 542
// module chunks = 85